import { QueryClient } from "@tanstack/react-query"
import { ProductID } from "@imago/model"
import { FatUserQuery } from "./user.ts"

export const InventoryQuery = {
	use() {
		return {data: FatUserQuery.use().data?.inventory}
	},
	async setData(qc: QueryClient, k: [], inventory: ProductID[]) {
		await FatUserQuery.patchData(qc, [], old => ({
			...old!,
			inventory,
		}))
	},
	async invalidate(qc: QueryClient, k: []) {
		await FatUserQuery.invalidate(qc, [])
	},
}

function useInventory() {
	return InventoryQuery.use().data
}

export function useOwns(productID: ProductID) {
	const inventory = useInventory()
	return inventory?.includes(productID)
}
